import userService from 'Services/UserService'

// initial state
const state = {
  users: []
}

// getters
const getters = {
  user: state => userId => state.users.find(user => user.userId === userId)
}

const actions = {
  filterUsers: ({ commit }, { filterContext }) => {
    const { request, cancelToken } = userService.getAll(filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setUsers', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getUsers: ({ dispatch }) => {
    return dispatch('filterUsers').then(({ promise }) => promise.then(result => result.data))
  },

  getUser: ({ commit }, { userId, parameters }) => {
    return userService.get(userId, parameters).then(result => {
      commit(state.users.some(item => item.userId === result.userId) ? 'updateUser' : 'setUser', result)

      return result
    })
  },

  addUser: ({ commit }, user) => {
    return userService.add(user).then((result) => {
      commit('setUser', result)

      return result
    })
  },

  updateUser: ({ dispatch }, { userId, user, parameters }) => {
    return userService.update(userId, user).then(() => {
      return dispatch('getUser', { userId, parameters })
    })
  }
}

// mutations
const mutations = {
  setUsers (state, users) {
    state.users = users
  },

  setUser (state, user) {
    state.users.push(user)
  },

  updateUser (state, user) {
    state.users = state.users.map(item =>
      item.userId === user.userId ? user : item
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
